module.exports = __webpack_public_path__ + "static/img/study_report.f1ccf874.png";